import { render, staticRenderFns } from "./SortingList.vue?vue&type=template&id=f36a9dc0&"
import script from "./SortingList.vue?vue&type=script&lang=js&"
export * from "./SortingList.vue?vue&type=script&lang=js&"
import style0 from "./SortingList.vue?vue&type=style&index=0&id=f36a9dc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports